import React from 'react'
import "./How_To_Play_Game_tab_content.css"
function How_To_Play_Game_tab_content() {
    return (
        <>
            <section className='How_To_Play_Game_tab_content'>
                <div className="content_holder">
                    <div className="main_text_holder">
                        <h4>Roulette is a casino game where you bet on where a small ball will land on a spinning wheel.</h4>
                    </div>

                    <div className="list_text_holder">
                        <ul>
                            <div className="list_heading_holder">
                                <h6>1. The Roulette Wheel & Table</h6>
                            </div>
                            <li>
                                <p>The wheel has numbers from 0 to 36 (sometimes also "00" in American roulette).</p>
                            </li>
                            <li>
                                <p>Numbers are red and black, but 0 (and 00) are green. </p>
                            </li>
                            <li>
                                <p> The table layout shows all these numbers and other betting options.</p>
                            </li>
                        </ul>
                    </div>


                    <div className="list_text_holder">
                        <ul>
                            <div className="list_heading_holder">
                                <h6>1. The Roulette Wheel & Table</h6>
                            </div>
                            <li>
                                <p>The wheel has numbers from 0 to 36 (sometimes also "00" in American roulette).</p>
                            </li>
                            <li>
                                <p>Numbers are red and black, but 0 (and 00) are green. </p>
                            </li>
                            <li>
                                <p> The table layout shows all these numbers and other betting options.</p>
                            </li>
                        </ul>
                    </div>


                    <div className="list_text_holder">
                        <ul>
                            <div className="list_heading_holder">
                                <h6>3. Types of Bets</h6>
                            </div>
                            <div className="list_table_holder">
                                <div className="row justify-content-center">
                                    <div className="col-lg-4 col-md-5">
                                        <div className="types_of_bets_box">

                                            <div className="card_heading_contant_holder">
                                                <div className="card_heading_holder">
                                                    <h1>Types Of Bets</h1>
                                                </div>

                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <div className="type_heading">
                                                            <h5> 🎯 Inside Bets</h5>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="type_subheading">
                                                            <p>(on specific numbers or small groups)</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="card_content_text_holder">
                                                <div className="type_text_holder">
                                                    <h6>A. STRAIGHT UP</h6>
                                                    <p>Bet on 1 number (e.g., 17). Pays 35 to 1.</p>
                                                </div>
                                                <div className="type_text_holder">
                                                    <h6>B. SPLIT</h6>
                                                    <p>Bet on 2 numbers (e.g., 14 & 17). Pays 17 to 1.</p>
                                                </div>
                                                <div className="type_text_holder">
                                                    <h6>C. STREET</h6>
                                                    <p>Bet on 3 numbers in a row. Pays 11 to 1.</p>
                                                </div>
                                                <div className="type_text_holder">
                                                    <h6>D. CORNER</h6>
                                                    <p>Bet on 4 numbers forming a square. Pays 8 to 1.</p>
                                                </div>
                                                <div className="type_text_holder">
                                                    <h6>E. LINE</h6>
                                                    <p>Bet on 6 numbers in two rows. Pays 5 to 1.</p>
                                                </div>
                                            </div>


                                        </div>

                                    </div>

                                    <div className="col-lg-4 col-md-5">
                                        <div className="types_of_bets_box">

                                            <div className="card_heading_contant_holder">
                                                <div className="card_heading_holder">
                                                    <h1>Types Of Bets</h1>
                                                </div>

                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <div className="type_heading">
                                                            <h5> 🎯 Inside Bets</h5>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="type_subheading">
                                                            <p>(on specific numbers or small groups)</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="card_content_text_holder">
                                                <div className="type_text_holder">
                                                    <h6>A. STRAIGHT UP</h6>
                                                    <p>Bet on 1 number (e.g., 17). Pays 35 to 1.</p>
                                                </div>
                                                <div className="type_text_holder">
                                                    <h6>B. SPLIT</h6>
                                                    <p>Bet on 2 numbers (e.g., 14 & 17). Pays 17 to 1.</p>
                                                </div>
                                                <div className="type_text_holder">
                                                    <h6>C. STREET</h6>
                                                    <p>Bet on 3 numbers in a row. Pays 11 to 1.</p>
                                                </div>
                                                <div className="type_text_holder">
                                                    <h6>D. CORNER</h6>
                                                    <p>Bet on 4 numbers forming a square. Pays 8 to 1.</p>
                                                </div>
                                                <div className="type_text_holder">
                                                    <h6>E. LINE</h6>
                                                    <p>Bet on 6 numbers in two rows. Pays 5 to 1.</p>
                                                </div>
                                            </div>


                                        </div>

                                    </div>
                                </div>
                            </div>
                        </ul>
                    </div>

                    <div className="list_text_holder">
                        <ul>
                            <div className="list_heading_holder">
                                <h6>1. The Roulette Wheel & Table</h6>
                            </div>
                            <li>
                                <p>The wheel has numbers from 0 to 36 (sometimes also "00" in American roulette).</p>
                            </li>
                            <li>
                                <p>Numbers are red and black, but 0 (and 00) are green. </p>
                            </li>
                            <li>
                                <p> The table layout shows all these numbers and other betting options.</p>
                            </li>
                        </ul>
                    </div>
                </div>
            </section>
        </>
    )
}

export default How_To_Play_Game_tab_content